package ru.playa.sce.dto

class CoreSearch(
        val id: Int,
        val code: String,
        val objectType: String,
        val published: Location?,
        val draft: Location?
)
